/**
 * Optional Vercel env: REACT_APP_GIDEON_WHATSAPP_URL — WhatsApp group invite link shown after enlist when users opt in.
 */
export const getGideonWhatsAppInviteUrl = () =>
  (typeof process !== 'undefined' && process.env.REACT_APP_GIDEON_WHATSAPP_URL) || '';
